module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-9b2a56de08500fccc78c57639f7c0c5d.svg";